exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-icon-document-copy[data-v-70191abe] {\n    color: #0d5aff;\n}\n.text-copy[data-v-70191abe] {\n    cursor: pointer;\n    -webkit-text-decoration-style: dotted;\n            text-decoration-style: dotted;\n    border-bottom: 1px dotted;\n    margin-left: 0px !important;\n}\n.text-copy-icon[data-v-70191abe] {\n    color: #b7b7b7;\n}\n", ""]);

// exports
